import { throwInvalidParameter } from './errors'
import { getObjectKeys } from './tools'
import { deserialize } from 'object-deserializer'
import { AppErrorCode, throwError } from './errors'

export enum ContentType {
  APPLICATION_JSON = 'application/json',
}

export function isContentType(value: string, contentType: ContentType) {
  const parts = value.split(';')
  return parts.length > 0 ? parts[0] === contentType : false
}

export enum HttpHeader {
  AUTHORIZATION = 'Authorization',
  CONTENT_TYPE = 'Content-Type',
  X_REQUEST_ID = 'X-Request-Id',
  ACCEPT_LANGUAGE = 'Accept-Language',
  USER_AGENT = 'User-Agent',
}

export function getHeaderValue(headers: Record<string, unknown>, header: HttpHeader | string): string | undefined {
  const key = getObjectKeys(headers).find(k => k.toLowerCase() === header.toLowerCase())
  if (!key) return
  const value = headers[key]
  if (!value) return
  if (typeof value !== 'string') throwInvalidParameter('<cad06cac>')
  return value
}

interface ErrorInfo {
  uid?: string
  code: string
  message: string
}

export function parseJsonAppError(contentType: unknown, data: object): ErrorInfo | undefined {
  if (!contentType) return
  if (typeof contentType !== 'string') throwError(AppErrorCode.INVALID_PARAMETER, '<4d8e7dde>')
  if (!isContentType(contentType, ContentType.APPLICATION_JSON)) return
  if ((data as Record<string, string>)['result'] !== 'error') return
  return deserialize(data, d => ({
    uid: d.optional('error.uid')?.asString,
    code: d.required('error.code').asString,
    message: d.required('error.message').asString,
  }))
}
